export const SITE = {
  // Navigation
  navRoot: 'site-nav',
  navLogo: 'site-nav-logo',
  navLinkHome: 'site-nav-link-home',
  navLinkAbout: 'site-nav-link-about',
  navLinkLessons: 'site-nav-link-lessons',
  navLinkTestimonials: 'site-nav-link-testimonials',
  navLinkContact: 'site-nav-link-contact',
  navCtaBook: 'site-nav-cta-book',
  navMobileToggle: 'site-nav-mobile-toggle',
  navMobileMenu: 'site-nav-mobile-menu',

  // Hero
  hero: 'hero',
  heroHeadline: 'hero-headline',
  heroSubheadline: 'hero-subheadline',
  heroCta: 'hero-cta-book',

  // About
  about: 'about',
  aboutPortrait: 'about-portrait',

  // Inspiration
  inspiration: 'inspiration',

  // Lessons
  lessons: 'lessons',
  lessonsPricingCard: 'lessons-pricing-card',
  lessonsCta: 'lessons-cta-schedule',

  // Benefits
  benefits: 'benefits',
  benefitItem: (slug) => `benefit-${slug}`,

  // Conservation
  conservation: 'conservation',

  // Reminder
  reminder: 'reminder',

  // Gallery
  gallery: 'gallery',
  galleryItem: (idx) => `gallery-item-${idx}`,

  // Testimonials (public + submit)
  testimonials: 'testimonials',
  testimonialsList: 'testimonials-list',
  testimonialCard: (id) => `testimonial-card-${id}`,
  testimonialsSubmitOpen: 'testimonials-submit-open',
  testimonialsForm: 'testimonials-form',
  testimonialsInputName: 'testimonials-input-name',
  testimonialsInputMessage: 'testimonials-input-message',
  testimonialsSubmit: 'testimonials-submit',

  // Contact / Request a Session form
  contact: 'contact',
  contactForm: 'contact-form',
  contactName: 'contact-input-name',
  contactEmail: 'contact-input-email',
  contactPhone: 'contact-input-phone',
  contactExperience: 'contact-input-experience',
  contactGroupSize: 'contact-input-group-size',
  contactMessage: 'contact-input-message',
  contactSubmit: 'contact-submit',
  contactPhoneLink: 'contact-phone-link',
  contactFacebookLink: 'contact-facebook-link',

  // Footer
  footer: 'site-footer',
  footerFacebook: 'footer-facebook',
  footerLinkedin: 'footer-linkedin',
  footerPhone: 'footer-phone',

  // Admin
  adminRoot: 'admin-root',
  adminLoginForm: 'admin-login-form',
  adminLoginUsername: 'admin-login-username',
  adminLoginPassword: 'admin-login-password',
  adminLoginSubmit: 'admin-login-submit',
  adminLogout: 'admin-logout',
  adminTabContact: 'admin-tab-contact',
  adminTabBookings: 'admin-tab-bookings',
  adminTabTestimonials: 'admin-tab-testimonials',
  adminTable: 'admin-submissions-table',
  adminBookingsTable: 'admin-bookings-table',
  adminBookingRow: (id) => `admin-booking-row-${id}`,
  adminRefreshBookings: 'admin-refresh-bookings',
  adminRow: (id) => `admin-row-${id}`,
  adminRefresh: 'admin-refresh',
  adminTestimonialsList: 'admin-testimonials-list',
  adminTestimonialRow: (id) => `admin-testimonial-row-${id}`,
  adminApproveBtn: (id) => `admin-testimonial-approve-${id}`,
  adminUnapproveBtn: (id) => `admin-testimonial-unapprove-${id}`,
  adminDeleteTestimonialBtn: (id) => `admin-testimonial-delete-${id}`,
  adminRefreshTestimonials: 'admin-refresh-testimonials',
};
